const CATEGORY = {
  OFFERS: {
    SERVER_LIMIT: 12,
    CLIENT_LIMIT: 24,
  },
};

export default CATEGORY;
